import Tooltip from "@mui/material/Tooltip";
import Zoom from "@mui/material/Zoom";

const InteractiveQuiz = ({onClose , InteractiveQuizequestion , cameFromHistoryPage , individualTitleFromHistory , notesContent}) => {

    const title = localStorage.getItem("title");

    const handleInteractivetext = () =>{
    let txtContent = `Quillionz\n`; //Title 
        txtContent+= "========================\n\n";

        InteractiveQuizequestion.forEach((question,index)=>{
            console.log("question in InteractiveQuizequestion",question);
            txtContent+= `Q${index + 1}: ${question.question || question.Question}\n`

            if (question.options){
                question.options.forEach((option,optindex)=>{
                    txtContent += `${optindex + 1}: ${option}\n`
                })
            }
            txtContent += `Answer: ${question.answer || question.Answer}\n\n`;
        })

        // Add notes section at the end
      txtContent += "Notes:\n";
      txtContent += notesContent + "\n"; // Add the content of notes
      
       const blob = new Blob([txtContent],{type:"text/plain;charset=utf-8"});
       const link = document.createElement("a");
       link.href = URL.createObjectURL(blob);
       link.download = `${
        cameFromHistoryPage ? individualTitleFromHistory : title
      }.txt`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    const handleRaptivityQuiz = (e)=>{
        e.preventDefault();
        window.open(`https://raptivity.com/create-interactive-quizzes-in-minutes.html?utm_source=qz&utm_medium=link`,'_blank')
    }
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
    {/* Black background with blur */}
    <div className="relative w-[100%] h-[100%] p-6 rounded-lg backdrop-blur-sm bg-black bg-opacity-50 flex justify-center items-center">
      <div className="bg-white shadow-lg text-[#212529] p-[1rem] rounded-lg animate-fade-slide-down w-[800px] h-[30%]">
        <div className="flex flex-col items-center justify-center h-full text-base font-segoe-ui-semilight">
          Export the Quillionz generated questions by clicking on ‘create text
          file’ button, then use the questions to create interactive quizzes
          using Raptivity interactions (Bowling Rush, Mountain Climb, Cheese
          Quest, Happy Meter)
          <div className="flex gap-5">
            {/* Currently we are commenting this. Later we need it. */}
            <div>
              <Tooltip
                title="Create Text File"
                arrow
                placement="top"
                TransitionComponent={Zoom}
                TransitionProps={{ timeout: 300 }}
              >
                <button
                onClick={handleInteractivetext}
                  className="rounded bg-[#e06c24] hover:opacity-80 text-white px-4 py-2  mt-1 transition duration-300 ease-in-out"
                >
                  {" "}
                  Create Text File
                </button>
              </Tooltip>
            </div>

            {/* Currently we are commenting this. Later we need it. */}
            <div>
              <Tooltip
                title="Create Raptivity Quiz"
                arrow
                placement="top"
                TransitionComponent={Zoom}
                TransitionProps={{ timeout: 300 }}
              >
                <button
                    onClick={handleRaptivityQuiz}
                  className="rounded bg-[#224575] hover:opacity-80 text-white px-4 py-2 mt-1 transition duration-300 ease-in-out"
                >
                  Create Raptivity Quiz
                </button>
              </Tooltip>
            </div>
            <div>
              <Tooltip
                title="Cancel"
                arrow
                placement="top"
                TransitionComponent={Zoom}
                TransitionProps={{ timeout: 300 }}
              >
                <button
                    onClick={onClose}
                  className="rounded border border-[#f4833d] text-[#f4833d] hover:bg-[#f4833d] hover:text-white px-4 py-2 mt-1 transition duration-300 ease-in-out"
                >
                  Cancel
                </button>
              </Tooltip>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
  );
};

export default InteractiveQuiz;
